import { render, staticRenderFns } from "./TabEditorSideSheet.vue?vue&type=template&id=cce003fa&scoped=true"
import script from "./TabEditorSideSheet.vue?vue&type=script&lang=js"
export * from "./TabEditorSideSheet.vue?vue&type=script&lang=js"
import style0 from "./TabEditorSideSheet.vue?vue&type=style&index=0&id=cce003fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce003fa",
  null
  
)

export default component.exports